import React from 'react';
import './InputModeToggle.css';

interface InputModeToggleProps {
  isLetterPicker: boolean;
  onToggle: () => void;
  title?: string;
}

const InputModeToggle: React.FC<InputModeToggleProps> = ({
  isLetterPicker,
  onToggle,
  title = 'Switch input mode',
}) => {
  return (
    <button
      className="input-mode-toggle"
      onClick={onToggle}
      title={title}
      type="button"
    >
      {isLetterPicker ? (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="6" width="20" height="12" rx="2" />
          <line x1="6" y1="10" x2="6" y2="10" /><line x1="10" y1="10" x2="10" y2="10" /><line x1="14" y1="10" x2="14" y2="10" /><line x1="18" y1="10" x2="18" y2="10" />
          <line x1="8" y1="14" x2="16" y2="14" />
        </svg>
      ) : (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="7" height="7" rx="1.5" /><rect x="14" y="4" width="7" height="7" rx="1.5" />
          <rect x="3" y="13" width="7" height="7" rx="1.5" /><rect x="14" y="13" width="7" height="7" rx="1.5" />
          <text x="6.5" y="9.5" textAnchor="middle" fontSize="6" fill="currentColor" stroke="none" fontWeight="600">a</text>
          <text x="17.5" y="9.5" textAnchor="middle" fontSize="6" fill="currentColor" stroke="none" fontWeight="600">b</text>
          <text x="6.5" y="18.5" textAnchor="middle" fontSize="6" fill="currentColor" stroke="none" fontWeight="600">c</text>
          <text x="17.5" y="18.5" textAnchor="middle" fontSize="6" fill="currentColor" stroke="none" fontWeight="600">d</text>
        </svg>
      )}
    </button>
  );
};

export default InputModeToggle;
